import { Pipe, PipeTransform } from '@angular/core';
import { months } from '@utils/months';

@Pipe({
  name: 'getMonthName',
})
export class GetMonthNamePipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 1:
        return months[value - 1].wartosc;
      case 2:
        return months[value - 1].wartosc;
      case 3:
        return months[value - 1].wartosc;
      case 4:
        return months[value - 1].wartosc;
      case 5:
        return months[value - 1].wartosc;
      case 6:
        return months[value - 1].wartosc;
      case 7:
        return months[value - 1].wartosc;
      case 8:
        return months[value - 1].wartosc;
      case 9:
        return months[value - 1].wartosc;
      case 10:
        return months[value - 1].wartosc;
      case 11:
        return months[value - 1].wartosc;
      case 12:
        return months[value - 1].wartosc;
      default:
        return '';
    }
  }
}
